import React, { useMemo, useState, JSX } from "react";
import { colors, css, fonts } from "../../../Styles";
import { NewInput } from "../..";
import { NewFieldStyles, NewFieldTypes } from "../../../Definitions";
import { CellContext } from "@tanstack/react-table";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
import { getGraphColor } from "../../../Styles/colors";
import { IdentifiableRow } from "../reactiveTableRenderer";

import { isObject } from "lodash";

export const ProgressTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn}: CellContext<T, JSX.Element | string | undefined> & EditAbleCell) => {
  const initialValue = useMemo(() => getValue(), [getValue]);

  const [value, setValue] = useState(initialValue);
  const key = `${row.original.id}-${column.id}`;

  if (isObject(value)) {
    return (
      <div style={{opacity: canEdit ? "0.5" : "1"}}>
        {value}
      </div>
    )
  }

  const onBlur = () => {
    if (value !==initialValue) {
      table.options.meta?.updateData(row.original.id, column.id, value, row)
    }
  }

  return <StyledProgressCell staticColumn={staticColumn} key={key} keyPass={key+"input"} onBlur={onBlur} onChange={(e: string) => setValue(e)} canEdit={canEdit} cellData={{value, style:{backgroundColor: getGraphColor(row.original.id), ...css.colorTag, ...fonts.header, ...fonts.fontSize4, color: colors.whitePrimary}}} />
}


const StyledProgressCell = ({onBlur, onChange, canEdit, cellData, keyPass, staticColumn}: StyledTableCellProps & EditAbleCell) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 0.5 }} key={keyPass}>
          {String(cellData.value)}
        </div>
      );
    } else {
      return (
        <NewInput
          key={keyPass}
          onChange={onChange}
          fieldOverrides={{
            fieldStyle: NewFieldStyles.greyTertiary,
            fieldType: NewFieldTypes.tertiaryField,
            fieldWidth: "100%"
          }}
          valueOverrides={{
            defaultValue: cellData.value,
            valueType: "string"
          }}
          // keyPass={keyPass}
          // context={cellData.value}
          // fieldStyle={FieldStyles.greyTertiary}
          // fieldType={FieldTypes.editField}
          // textStart
          // inTable
          // inputType="string"
          // onChange={onChange}
          // onBlur={onBlur}
          // key={keyPass}
          // initialIsFocused={!cellData.value ? true: false}
        />
      );
    }
  }

  return (
    <div style={cellData.style} key={keyPass}>
      {String(cellData.value)}
    </div>
  )
} 
